import {
  Admin,
  DashboardIcon,
  Unloading,
  WashingArea,
  RejectionSvg,
  Receiving,
  Ripening,
  SortingSvg,
  ColdStorageSvg,
  RipeningRoomSvg,
  WashingRipening,
  ProcessingSvg,
  Processing,
  CookingSvg,
  Packing,
  PackingSvg,
  Rework,
  GreenRoom,
  Refrigeration,
  MaterialEntered,
  Brokerage,
  Attendence, EmployeeLog, BillingExpense
} from "../components/layout/sidebar/Sidebarsvg";


export const permissionConfig = [
    {
        title: "Dashboard",
        path: "/dashboard",
        icon: <DashboardIcon />,
        permission_key: "all",
        permission_module: "main",
        subMenu: [],
    },
    // Receiving Module
    {
        title: "Receiving",
        path: "#",
        icon: <Receiving />,
        permission_module: "receiving",
        subMenu: [
            { title: "Overview", path: "/receiving-dashboard", permission_key: "receiving.dashboard"},
            { title: "Unloading", path: "/unloading",permission_key: "receiving.unloading" },
            { title: "Washing Area", path: "/washing-area" ,permission_key: "receiving.washing"},
            { title: "Rejection Log", path: "/rejection" ,permission_key: "receiving.rejectionlog" },
        ],
    },
    {
        title: "Ripening",
        path: "#",
        icon: <Ripening />,
        permission_module: "ripening",
        subMenu: [
            { title: "Overview", path: "/ripening-dashboard" , permission_key: "ripening.dashboard" },
            { title: "Cold Storage", path: "/cold-storage" , permission_key: "ripening.cold_storage" },
            { title: "Ripening Rooms", path: "/ripening-room" , permission_key: "ripening.ripening_rooms" },
            { title: "Sorting", path: "/sorting" , permission_key: "ripening.sorting" },
        ],
    },
    {
        title: "Processing",
        path: "#",
        icon: <ProcessingSvg />,
        permission_module: "processing",
        subMenu: [
            { title: "Overview", path: "/processing-dashboard" ,permission_key: "processing.dashboard"},
            { title: "Processing", path: "/processing" ,permission_key: "processing.processing"},
            { title: "Oven", path: "/cooking" ,permission_key: "processing.cooking"},
            { title: "Gas Consumption", path: "/gas-consumtion" ,permission_key: "processing.gas_consumption"},
        ],
    },
    {
        title: "Packing",
        path: "#",
        icon: <Packing />,
        permission_module: "packing",
        subMenu: [
            { title: "Overview", path: "/packing-dashboard",permission_key: "packing.dashboard" },
            { title: "Bagging", path: "/bagging",permission_key: "packing.bagging" },
            { title: "Sorting", path: "/packing-sorting",permission_key: "packing.sorting" },
            { title: "Packing", path: "/packing",permission_key: "packing.packing" },
        ],
    },
    
    {
        title: "Rework",
        path: "#",
        icon: <Rework />,
        permission_module: "rework",
        subMenu: [
            { title: "Overview", path: "/rework-dashboard", permission_key: "rework.dashboard" },
            { title: "Rework Area", path: "/rework", permission_key: "rework.rework_area" },
            { title: "Rework Packing", path: "/rework-packing", permission_key: "rework.rework_packing" },
            { title: "Humid", path: "/humid", permission_key: "rework.humid" },
            { title: "Toasted", path: "/toasted", permission_key: "rework.toasted" },
            { title: "Green", path: "/green-room", permission_key: "rework.green" },
        ],
    },
    {
        title: "Brokerage",
        path: "#",
        icon: <Brokerage />,
        permission_module: "brokerage",
        subMenu: [
            { title: "Overview", path: "/brokerage-dashboard" ,permission_key: "brokerage.dashboard"},
            { title: "Material Entered", path: "/material-entered" ,permission_key: "brokerage.material_entered"},
            { title: "Packing & Sorting", path: "/packing-and-sorting" ,permission_key: "brokerage.packing_and_sorting"},
            { title: "Turn 2", path: "/turn-2", permission_key: "brokerage.turn_2" },
        ],
    },
    {
        title: "Pasting",
        path: "#",
        icon: <Packing />,
        permission_module: "pasting",
        subMenu: [
            { title: "Overview", path: "/pasting-dashboard", permission_key: "pasting.dashboard" },
            { title: "Mixing", path: "/mixing", permission_key: "pasting.mixing" },
            { title: "Pasting", path: "/pasting", permission_key: "pasting.pasting" },
        ],
    },
    {
        title: "Refrigeration",
        path: "/refrigeration-area",
        icon: <Refrigeration />,
        permission_key: "refrigeration.refrigeration",
        permission_module: "refrigeration",
        subMenu: [],
    },
    {
        title: "Cleaning",
        path: "/ripening-washing",
        icon: <WashingArea />,
        permission_key: "cleaning.cleaning",
        permission_module: "cleaning",
        subMenu: [],
    },
    {
        title: "Admin",
        path: "#",
        icon: <Admin />,
        permission_module: "admin",
        subMenu: [
            { title: "Suppliers", path: "/supplier" ,permission_key: "admin.supplier"},
            { title: "Manager", path: "/manager" ,permission_key: "admin.manager"},
            /* { title: "Employee", path: "/employee" ,permission_key: "admin.employee"}, */
            { title: "Role & Permission", path: "/role-and-permission" ,permission_key: "admin.role_and_permission"},
        ],
    },
    {
        title: "Expense",
        path: "#",
        icon: <BillingExpense />,
        permission_module: "expenses",
        subMenu: [
            { title: "Bill Creation", path: "/bill-creation" ,permission_key: "expenses.bill_creation" },
            { title: "Unpaid Bills", path: "/bill-listing",permission_key: "expenses.bill_listing" },
            { title: "Edit Bill", path: "/bill-report/:id", permission_key: "expenses.bill_listing", hidden: true },
            { title: "Paid bill report", path: "/bill-report",permission_key: "expenses.bill_report" },
        ],
    }
];